import { mdiAlertCircleOutline, mdiCheckCircleOutline, mdiInformationOutline, mdiProgressClock } from '@mdi/js'
import Icon from '@mdi/react'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import Box from '@mui/system/Box'
import { PPDialog } from 'components/PPDialog'
import { formatCommentDelayShort } from 'components/Composer/Network/CommentTextBox/CommentTextBox'
import { format } from 'date-fns'
import { Fragment } from 'react'
import { BRAND_FACEBOOK } from 'shared'
import { PostedPostComment } from 'shared/types'
import { buildHTMLWithTags } from 'utils/composer'
import styles from './PostCommentsPopup.pcss'

const css = require('styles/variables')


export function PostCommentsPopup({ comments, open, isPosted, network, onClose }: {
  comments: PostedPostComment[], open: boolean, isPosted?: boolean, network: string, onClose: () => void
}) {
  const icons = {
    ok: <Icon path={mdiCheckCircleOutline} size="20px" color={css['--pp-green']} className={styles.icon} />,
    pending: <Icon path={mdiProgressClock} size="20px" color={css['--gray']} className={styles.icon} />,
    error: <Icon path={mdiAlertCircleOutline} size="20px" color={css['--alert-red']} className={styles.icon} />
  }

  const showTextOnly = !isPosted

  const iconTooltips = {
    ok: 'Published successfully',
    pending: 'Pending',
    error: 'Failed to post comment'
  }

  return (
    <PPDialog open={open} onClose={onClose} size="lg" title="Comments">
      <div className={styles.content}>
        <Box className={`${styles.header} ${styles.commentBox}`}>
          <div className={styles.order}>#</div>
          <div className={styles.delay}>
            Delay
            <Tooltip title="Delay is relative to previous comment (or to post for first comment)">
              <div style={{ height: '16px', display: 'inline-block', marginLeft: '4px', verticalAlign: 'middle' }}>
                <Icon path={mdiInformationOutline} size="16px" />
              </div>
            </Tooltip>
          </div>
          {!showTextOnly && (
            <Fragment>
              <div className={styles.time}>Published at</div>
              <div className={styles.status}>Status</div>
            </Fragment>
          )}
          <div className={styles.text}>Comment</div>
        </Box>
        <div className={showTextOnly ? styles.divided : undefined}>
          {comments.length === 0 && <Typography>No comments available.</Typography>}
          {comments.map((comment, index) => {
            let text = comment.text
            let html: string | undefined = undefined
            if (network === BRAND_FACEBOOK) {
              html = buildHTMLWithTags(text, comment.tags || [], BRAND_FACEBOOK)
              text = ''
            }
            return (
              <Box key={index} className={styles.commentBox} mb={2}>
                <div className={styles.order}>#{index + 1}</div>
                <div className={styles.delay}>{formatCommentDelayShort(comment.delay)}</div>
                {!showTextOnly && (
                  <Fragment>
                    <div className={styles.time}>
                      {comment.publishedAt ? format(new Date(comment.publishedAt), 'MMM dd, hh:mm a') : 'Not Published'}
                    </div>
                    <div className={styles.status}>
                      <Tooltip title={iconTooltips[comment.status!]}>
                        <span>{icons[comment.status!]}</span>
                      </Tooltip>
                    </div>
                  </Fragment>
                )}
                <div className={styles.text}>
                  {text}
                  {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
                  {comment.errorMessage && <div className={styles.error}>Error: {comment.errorMessage}</div>}
                </div>
              </Box>
            )
          })}
        </div>
      </div>
    </PPDialog>
  )
}
